import {REMOTE_CONFIG_KEYS} from '../configs/remoteConfigKeys';

const BASE_PATH = REMOTE_CONFIG_KEYS.TERMS_POLICY_CONTENT;

export const REMOTE_CONFIG_PATHS = {
  MERCHANT_POLICY: {
    INITIAL_TEXT: `${BASE_PATH}.merchant_accreditation_policy.initial_text`,
    DECLARATION: `${BASE_PATH}.merchant_accreditation_policy.declaration`,
    SECTIONS: {
      ACCREDITATION_REQUIREMENTS: `${BASE_PATH}.merchant_accreditation_policy.sections.accreditation_requirements`,
      WORKER_FOOD_PROGRAM: `${BASE_PATH}.merchant_accreditation_policy.sections.worker_food_program`,
      SIGNALING_ESTABLISHMENTS: `${BASE_PATH}.merchant_accreditation_policy.sections.signaling_establishments`,
      DISACCEPTANCE_EC: `${BASE_PATH}.merchant_accreditation_policy.sections.disacceptance_ec`,
      ALELO_INSPECTION: `${BASE_PATH}.merchant_accreditation_policy.sections.alelo_inspection`
    }
  },
  TERMS_CONDITIONS: {
    INITIAL_TEXT: `${BASE_PATH}.terms_conditions.initial_text`,
    ASTERISK_DISCLAIMER: `${BASE_PATH}.terms_conditions.asterisk_disclaimer`,
    OBSERVATIONS: `${BASE_PATH}.terms_conditions.observations`,
    LEGEND: `${BASE_PATH}.terms_conditions.legend`,
    DECLARATION: `${BASE_PATH}.terms_conditions.declaration`
  },
  PRIVACY_POLICY: {
    INITIAL_TEXT: `${BASE_PATH}.privacy_policy.initial_text`,
    WHAT_DATA_COLLECT: `${BASE_PATH}.privacy_policy.sections.what_data_collect`,
    PERSONAL_DATA: `${BASE_PATH}.privacy_policy.sections.personal_data`,
    DATA_SHARING: `${BASE_PATH}.privacy_policy.sections.data_sharing`,
    INTERNATIONAL_DATA_TRANSFER: `${BASE_PATH}.privacy_policy.sections.international_data_transfer`,
    INTERACTIONS_THIRD_PARTIES: `${BASE_PATH}.privacy_policy.sections.interactions_third_parties`,
    RIGHTS_HOLDER_PERSONAL_DATA: `${BASE_PATH}.privacy_policy.sections.rights_holder_personal_data`,
    ADDITIONAL_CONTROLS: `${BASE_PATH}.privacy_policy.sections.additional_controls`,
    TERMINATION_PROCESSING: `${BASE_PATH}.privacy_policy.sections.termination_processing`,
    GET_IN_TOUCH: `${BASE_PATH}.privacy_policy.sections.get_in_touch`,
    CONTACT_INFO: `${BASE_PATH}.privacy_policy.sections.contact_info`
  }
};
